<template>
  <span class="text-body-2 red-underline-animation px-2">
    <router-link :to="to">&larr;<slot /></router-link>
  </span>
</template>

<script>
export default {
  name: "BreadcrumbRouterLink",
  props: {
    to: {
      type: [String, Object],
      required: true
    }
  }
};
</script>